import { split, map, isNil } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Strong from 'components/Strong';

const HighlightText = ({ textToHighlight, sentence }) => {
  const parts = split(sentence, new RegExp(`(${textToHighlight})`, 'gi'));

  if (!textToHighlight && !isNil(sentence)) {
    return <span className="HighlightText__container">{sentence}</span>;
  }

  return (
    <span className="HighlightText__container">
      {textToHighlight &&
        sentence &&
        map(parts, (part, index) =>
          part?.toLowerCase() === textToHighlight?.toLowerCase() ? (
            <Strong className="HighlightText__highlight" key={`${index + part}`}>
              {part}
            </Strong>
          ) : (
            <span className="HighlightText__not_highlight" key={`${index + part}`}>
              {part}
            </span>
          )
        )}
      <style jsx>
        {`
          .HighlightText__container {
            width: 100%;
          }
        `}
      </style>
    </span>
  );
};

HighlightText.propTypes = {
  textToHighlight: PropTypes.string.isRequired,
  sentence: PropTypes.string.isRequired,
};

export default HighlightText;
